import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_QUILLDOCUMENT_LOAD_BY_ID,
    ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE,
    ACTION_QUILLDOCUMENT_SEARCH,

    ACTION_QUILLDOCUMENT_SAVE,

    ACTION_QUILLDOCUMENT_VALIDATE,

    ACTION_QUILLDOCUMENT_CREATE,

    IQuillDocumentLoadByIdAction,
    IQuillDocumentLoadByTypeAndPageAction,
    IQuillDocumentsSearchAction,
    IQuillDocumentLoadFailureAction,
    IQuillDocumentLoadSuccessAction,

    IQuillDocumentSaveAction,
    IQuillDocumentSaveSuccessAction,
    IQuillDocumentSaveFailureAction,

    IQuillDocumentCreateAction,
    IQuillDocumentCreateSuccessAction,
    IQuillDocumentCreateFailureAction,

    IQuillDocumentsSearchSuccessAction,
    IQuillDocumentsSearchFailureAction,
    IQuillDocumentValidateSuccessAction,
    IQuillDocumentValidateFailureAction,
    IQuillDocumentValidateAction,

    LoadSuccess,
    LoadFailure,

    SearchSuccess,
    SearchFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateFailure,
    ValidateSuccess,

} from "../actions/quillDocument";
import { quillDocumentApi } from "../services/quillDocument";


export const
    getQuillDocumentByIdEpic = (action$): Observable<IQuillDocumentLoadSuccessAction | IQuillDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENT_LOAD_BY_ID)
            .mergeMap((action: IQuillDocumentLoadByIdAction) => {
                return quillDocumentApi
                    .getQuillDocumentById(action.id)
                    .map(response =>
                        LoadSuccess(response.quillDocument, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getQuillDocumentByTypeAndPageEpic = (action$): Observable<IQuillDocumentLoadSuccessAction | IQuillDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE)
            .mergeMap((action: IQuillDocumentLoadByTypeAndPageAction) => {
                return quillDocumentApi
                    .getQuillDocumentByTypeAndPage(action.quillDocumentType, action.page)
                    .map(response =>
                        LoadSuccess(response.quillDocument, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getQuillDocumentsBySearchEpic = (action$): Observable<IQuillDocumentsSearchSuccessAction | IQuillDocumentsSearchFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENT_SEARCH)
            .mergeMap((action: IQuillDocumentsSearchAction) => {
                return quillDocumentApi
                    .getQuillDocumentsBySearch(action.search)
                    .map(response =>
                        SearchSuccess(response.quillDocuments, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(SearchFailure(error.responseStatus))
                    )
            });
    },
    setQuillDocumentEpic = (action$): Observable<IQuillDocumentSaveSuccessAction | IQuillDocumentSaveFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENT_SAVE)
            .mergeMap((action: IQuillDocumentSaveAction) => {
                return quillDocumentApi
                    .setQuillDocument(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.quillDocument, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createQuillDocumentEpic = (action$): Observable<IQuillDocumentCreateSuccessAction | IQuillDocumentCreateFailureAction> => {
        return action$
            .ofType(ACTION_QUILLDOCUMENT_CREATE)
            .mergeMap((action: IQuillDocumentCreateAction) => {
                return quillDocumentApi
                    .createQuillDocument(action.quillDocumentType, action.page)
                    .map(response =>
                        CreateSuccess(
                            response.quillDocument,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateQuillDocumentEpic = (action$): Observable<IQuillDocumentValidateSuccessAction | IQuillDocumentValidateFailureAction> => {
            return action$
                .ofType(ACTION_QUILLDOCUMENT_VALIDATE)
                .mergeMap((action: IQuillDocumentValidateAction) => {
                    return quillDocumentApi
                        .validateQuillDocument(action.formData)
                        .map(response => {
                            if (response.responseStatus &&
                                response.responseStatus.meta &&
                                response.responseStatus.meta.blockSave &&
                                response.responseStatus.meta.blockSave == "1") {
                                return ValidateFailure(response.responseStatus)
                            }
    
                            return ValidateSuccess(response.quillDocument, response.formState, response.responseStatus)
    
                        })
                        .catch(error =>
                            Observable.of(ValidateFailure(error.responseStatus))
                        )
                });
        }